<template>
  <el-dialog
      :title="isEdit?'编辑用户':'添加用户'"
      @open="init"
      @close="doClose"
      :destroy-on-close="true"
      :append-to-body="true"
      :visible.sync="visible"
      :modal-append-to-body="true"
      width="550px">
    <div class="user-save-page">
      <el-form :model="userForm" label-width="80px" ref="userForm" size="small" label-position="right">
        <el-form-item label="登录名" prop="loginName">
          <el-input v-model="userForm.loginName" placeholder="请输入用户登录名"></el-input>
        </el-form-item>
        <el-form-item label="真实姓名" prop="trueName">
          <el-input v-model="userForm.trueName" placeholder="请输入用户姓名"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="userForm.email" placeholder="请输入用户邮箱"></el-input>
        </el-form-item>
        <el-form-item label="电话" prop="phone">
          <el-input v-model="userForm.phone" placeholder="请输入用户联系方式"></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-radio-group v-model="userForm.sex">
            <el-radio :label="0">男</el-radio>
            <el-radio :label="1">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="分配职务" prop="name" :options="options">
          <el-select v-model="jobList" multiple placeholder="请选择" style="width: 100%">
            <el-option v-for="item in options" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分配机构" prop="parentId">
          <el-cascader @change="getOrgId" :options="option" v-model="parentIdEcho" :props="props" clearable style="width: 100%"></el-cascader>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="">
      <el-button size="small" @click="doClose()"><i class="fa fa-close"></i> 关闭</el-button>
      <el-button size="small" type="primary" @click="saveUser()"><i class="fa fa-save"></i> 保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { get, save, update } from '@/api/system/user'
import { fetchList } from '@/api/system/job'
import { tree } from '@/api/system/unit'
import { deepClone } from '@/utils'

export default {
  name: 'user-save',
  props: {
    user: null,
    visible: false
  },
  computed: {
    isEdit() {
      return this.user // 根据meta判断
    }
  },
  data() {
    return {
      options: [],
      option: [],
      props: {
        value: 'id',
        label: 'name',
        children: 'childrens'
      },
      parentIdEcho: [],
      rules: {
        name: [
          { required: false, message: '请为用户分配职务', trigger: 'blur' },
          { min: 1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'blur' }
        ],
        role: [{ required: true, message: '请选择用户角色', trigger: 'blur' }],
        loginName: [
          { required: true, message: '请输入用户名称', trigger: 'blur' },
          { min: 1, max: 10, message: '长度在 1 到 20 个字符', trigger: 'blur' }
        ],
        trueName: [
          { required: true, message: '请输入用户名称', trigger: 'blur' },
          { min: 1, max: 10, message: '长度在 1 到 20 个字符', trigger: 'blur' }
        ],
        email: [{ required: true, message: '请输入用户邮箱', trigger: 'change' }],
        phone: [{ required: true, message: '请输入用户联系方式', trigger: 'change' }]
      },
      jobList: [],
      userForm: {}
    }
  },
  methods: {
    init(){
      this.getJob()
      this.getEcho()
      if (this.isEdit) {
        this.getUser()
      }
    },
    getOrgId(list) {
      this.userForm.orgId = list[list.length - 1]
    },
    getUser() {
      get(this.user.id).then(resp => {
        let info = resp.data.result || {}
        let arr = []

        this.jobList = arr
        info.orgId = info.organization ? (info.organization.id || '') : ''
        this.$set(this,'userForm',info)
        this.parentIdEcho = info.orgIds ? JSON.parse(info.orgIds) : []

        if(info.jobIds){
          info.jobIds.map(item => {
            arr.push(item.id)
          })
        }
      })
    },
    saveUser() {
      this.$refs['userForm'].validate(valid => {
        if (valid) {
          if (!(/^1[3456789]\d{9}$/.test(this.userForm.phone))) {
            this.$message.warning('请输入正确的手机号码')
          } else {
            this.userForm.jobIds = this.jobList || []
            let info = deepClone(this.userForm)
            info.orgIds = JSON.stringify(this.parentIdEcho)
            info.type=0
            delete info.organization
            if (this.isEdit) {
              update(info).then(resp => {
                this.submitCallback(resp)
              })
            } else {
              save(info).then(resp => {
                this.submitCallback(resp)
              })
            }
          }
        }
      })
    },
    submitCallback(resp) {
      if (resp.status === 200) {
        this.$message.success(resp.data.message)
        this.$emit('done', true)
      }
    },
    doClose() {
      this.$emit('done', false)
    },
    getJob() {
      fetchList().then(resp => {
        this.options = resp.data.result
      })
    },
    getEcho() {
      tree().then(resp => {
        this.option = resp.data.result
      })
    }
  }
}
</script>
